import React from 'react'

import CrudIntegracaoFormPageContainer from './CrudIntegracaoFormPageContainer'

export class CrudIntegracaoFormPage extends React.Component {
  render() {
    return <CrudIntegracaoFormPageContainer {...this.props} />
  }
}
